import { render, staticRenderFns } from "./specialCategoriesSlide.vue?vue&type=template&id=196b739a&scoped=true&"
import script from "./specialCategoriesSlide.vue?vue&type=script&lang=js&"
export * from "./specialCategoriesSlide.vue?vue&type=script&lang=js&"
import style0 from "./specialCategoriesSlide.vue?vue&type=style&index=0&id=196b739a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b739a",
  null
  
)

export default component.exports